import { render, staticRenderFns } from "./ContPriceType.vue?vue&type=template&id=7c72b703&"
import script from "./ContPriceType.vue?vue&type=script&lang=js&"
export * from "./ContPriceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports